// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.iziToast{
    border-radius: 10px;
}

.iziToast:after{
    border: 1px solid yellow;
    border-radius: 10px;
}`, "",{"version":3,"sources":["webpack://./components/App/styleToast.css"],"names":[],"mappings":";AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;AACvB","sourcesContent":["\r\n.iziToast{\r\n    border-radius: 10px;\r\n}\r\n\r\n.iziToast:after{\r\n    border: 1px solid yellow;\r\n    border-radius: 10px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
